// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating label: the <label> comes after the control in the DOM so the
   sibling selector can react to the control's focus / filled state. */
.float-field {
  position: relative;
}

.float-field input,
.float-field textarea {
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border-default);
  border-radius: 10px;
  /* Extra top room for the floated label. */
  padding: 24px 14px 8px;
  font: inherit;
  color: var(--text-primary);
  background-color: var(--surface-raised);
}

.float-field textarea {
  min-height: 120px;
  resize: vertical;
}

.float-field input:focus,
.float-field textarea:focus {
  outline: 2px solid var(--focus-ring);
  border-color: var(--text-accent);
}

/* Hint text only while typing; when empty and idle the label is the prompt. */
.float-field input::placeholder,
.float-field textarea::placeholder {
  color: transparent;
}

.float-field input:focus::placeholder,
.float-field textarea:focus::placeholder {
  color: var(--text-primary);
  opacity: 0.55;
}

/* Resting: label centered in the box, like a placeholder. */
.float-field label {
  position: absolute;
  left: 15px;
  /* Long labels stay on one line inside the box on narrow screens. */
  right: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  top: 50%;
  transform: translateY(-50%);
  transform-origin: left top;
  pointer-events: none;
  color: var(--text-primary);
  font-weight: 500;
  transition: top 0.15s ease, transform 0.15s ease, font-size 0.15s ease;
}

.float-field-multiline label {
  top: 16px;
  transform: none;
}

/* A resting textarea has room, so a long label can wrap instead of being
   cut off. Once floated it goes back to one line. */
.float-field textarea:placeholder-shown:not(:focus) + label {
  white-space: normal;
}

/* Floated: small label in the top of the box. */
.float-field input:focus + label,
.float-field input:not(:placeholder-shown) + label,
.float-field textarea:focus + label,
.float-field textarea:not(:placeholder-shown) + label {
  top: 7px;
  transform: none;
  font-size: 0.78rem;
  font-weight: 600;
}

.float-field input:focus + label,
.float-field textarea:focus + label {
  color: var(--text-accent);
}

@media (prefers-reduced-motion: reduce) {
  .float-field label {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FloatingField.css"],"names":[],"mappings":"AAAA;sEACsE;AACtE;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,8EAA8E;AAC9E;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,UAAU;EACV,mEAAmE;EACnE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;oDACoD;AACpD;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;;;;EAIE,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Floating label: the <label> comes after the control in the DOM so the\n   sibling selector can react to the control's focus / filled state. */\n.float-field {\n  position: relative;\n}\n\n.float-field input,\n.float-field textarea {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--border-default);\n  border-radius: 10px;\n  /* Extra top room for the floated label. */\n  padding: 24px 14px 8px;\n  font: inherit;\n  color: var(--text-primary);\n  background-color: var(--surface-raised);\n}\n\n.float-field textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.float-field input:focus,\n.float-field textarea:focus {\n  outline: 2px solid var(--focus-ring);\n  border-color: var(--text-accent);\n}\n\n/* Hint text only while typing; when empty and idle the label is the prompt. */\n.float-field input::placeholder,\n.float-field textarea::placeholder {\n  color: transparent;\n}\n\n.float-field input:focus::placeholder,\n.float-field textarea:focus::placeholder {\n  color: var(--text-primary);\n  opacity: 0.55;\n}\n\n/* Resting: label centered in the box, like a placeholder. */\n.float-field label {\n  position: absolute;\n  left: 15px;\n  /* Long labels stay on one line inside the box on narrow screens. */\n  right: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  top: 50%;\n  transform: translateY(-50%);\n  transform-origin: left top;\n  pointer-events: none;\n  color: var(--text-primary);\n  font-weight: 500;\n  transition: top 0.15s ease, transform 0.15s ease, font-size 0.15s ease;\n}\n\n.float-field-multiline label {\n  top: 16px;\n  transform: none;\n}\n\n/* A resting textarea has room, so a long label can wrap instead of being\n   cut off. Once floated it goes back to one line. */\n.float-field textarea:placeholder-shown:not(:focus) + label {\n  white-space: normal;\n}\n\n/* Floated: small label in the top of the box. */\n.float-field input:focus + label,\n.float-field input:not(:placeholder-shown) + label,\n.float-field textarea:focus + label,\n.float-field textarea:not(:placeholder-shown) + label {\n  top: 7px;\n  transform: none;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.float-field input:focus + label,\n.float-field textarea:focus + label {\n  color: var(--text-accent);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .float-field label {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
